export class GaugeValue {
  constructor(
    private readonly previousValue: number,
    private readonly currentValue: number,
    private readonly unit: string = "",
    private readonly decimals: number = 0,
  ) {}

  get previous(): number {
    return this.previousValue;
  }

  get current(): number {
    return this.currentValue;
  }

  get delta(): number {
    return this.currentValue - this.previousValue;
  }

  get formatPrevious(): string {
    return this.previousValue.toFixed(this.decimals) + this.unit;
  }

  get formatCurrent(): string {
    return this.currentValue.toFixed(this.decimals) + this.unit;
  }

  get formatDelta(): string {
    return this.delta.toFixed(this.decimals) + this.unit;
  }

  get trend(): "up" | "down" | null {
    return this.delta === 0 ? null : this.delta > 0 ? "up" : "down";
  }
}
